import { render } from "./bank-transfer.vue?vue&type=template&id=9070a980&scoped=true"
import script from "./bank-transfer.vue?vue&type=script&lang=js"
export * from "./bank-transfer.vue?vue&type=script&lang=js"

import "./bank-transfer.vue?vue&type=style&index=0&id=9070a980&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9070a980"]])

export default __exports__